import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { templatesClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveTemplates($ids: [Int]) {
    removeTemplates(ids: $ids)
  }
`

export const useRemoveTemplate = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Templates', 'TemplatesCount'],
    client: templatesClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const { t } = useTranslation('common')

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!resp.errors) {
      } else {
        notify.error({ title: t('errorDelete') })
      }
    })
  }

  return [handleRequest, state]
}
